import { render, staticRenderFns } from "./detailScore.vue?vue&type=template&id=6f23fd88&scoped=true"
import script from "./detailScore.vue?vue&type=script&lang=js"
export * from "./detailScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f23fd88",
  null
  
)

export default component.exports